'use strict';

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();});
};

// Script Modules
// Include as needed on your project. All scripts will be bundled together.
// Some sample files are included for ideas to get you started.
require('./scripts/modal.js');
require('./scripts/sticky-header.js');
// require('./scripts/hoverIntent.js');
require('./scripts/header.js');
require('./scripts/menu.js');
require('./scripts/cover.js');
require('./scripts/smooth-scroll.js');
require('./scripts/toggle.js');
require('./scripts/cards.js');
require('./scripts/heading.js');
